<app-page-body>
  <!-- header -->
  <app-page-header
    [title]="title"
    [isForm]="true"
    [loading]="loading"
    (onBack)="onClose()"
    (onRefresh)="onReset()"
  >
  </app-page-header>

  <!-- content -->
  <div class="app-page-content">
    <!-- form -->
    <form [formGroup]="form" autocomplete="off">
      <section>
        <fieldset>
          <legend>{{ pageVocabs + "legend" | translate }}</legend>
          <div class="row">
            <!-- userId -->
            <div class="md:tw-w-1/2">
              <users-select-search
                type="currentOrganizationUsersList"
                [control]="form?.get('userId')"
                [(value)]="model.userId"
                [removable]="!formPageConfig.isEditMode"
                [isDisabled]="formPageConfig.isEditMode"
                (onError)="onClose()"
              >
              </users-select-search>
            </div>

            <!-- organizationId -->
            <div class="md:tw-w-1/2">
              <organization-select-search
                type="descendantAndItselfList"
                [removable]="!formPageConfig.isEditMode"
                [control]="form?.get('organizationId')"
                [(value)]="model.organizationId"
                [isDisabled]="formPageConfig.isEditMode"
                (onError)="onClose()"
              >
              </organization-select-search>
            </div>

            <!-- panelPercent -->
            <div class="sm:tw-w-1/2 xl:tw-w-1/3 2xl:tw-w-1/4">
              <form-field
                [(value)]="model.panelPercent"
                [control]="form?.get('panelPercent')"
                [label]="fields + 'panelPercent' | translate"
                [hasPercent]="true"
                [minLength]="1"
                [maxLength]="5"
                [min]="1"
                [max]="100"
              >
                <span suffix-content>
                  <i class="mdi mdi-percent"></i>
                </span>
              </form-field>
            </div>

            <!-- pricePerSms -->
            <div class="sm:tw-w-1/2 xl:tw-w-1/3 2xl:tw-w-1/4">
              <form-field
                [(value)]="model.pricePerSms"
                [hasCurrency]="true"
                [label]="fields + 'pricePerSms'"
                type="tel"
                [hasNumberSeparator]="true"
                [control]="form?.get('pricePerSms')"
              >
              </form-field>
            </div>

            <!-- target -->
            <div class="sm:tw-w-1/2 xl:tw-w-1/3 2xl:tw-w-1/4">
              <form-field
                [(value)]="model.target"
                type="tel"
                [hasNumberSeparator]="true"
                [control]="form?.get('target')"
                [label]="fields + 'target'"
              >
              </form-field>
            </div>

            <!-- expireDate -->
            <div class="sm:tw-w-1/2 xl:tw-w-1/3 2xl:tw-w-1/4">
              <datepicker
                label="common.expireDate"
                [isEdit]="formPageConfig.isEditMode"
                [value]="model.expireDate"
                (value)="model.expireDate = $event"
                [control]="form?.get('expireDate')"
                [minType]="formPageConfig.isEditMode ? 'unlimited' : 'today'"
                (onErrorDatePicker)="showErrorDialog($event)"
              >
              </datepicker>
            </div>
          </div>
        </fieldset>
      </section>

      <!-- form btns-->
      <app-form-btns
        [loading]="loading"
        [form]="form"
        [isEdit]="formPageConfig.isEditMode"
        (onClose)="onClose()"
        (onSubmit)="onSubmit()"
      >
      </app-form-btns>
    </form>
  </div>
</app-page-body>
